export default __webpack_public_path__ + "static/media/scolaza.3e0e6282.png";